import axios from 'axios';

// Use relative URLs so every request goes through the CRA dev proxy
// (package.json "proxy": "http://localhost:8000"). This works from the
// Replit preview pane, a new Replit tab, AND an external browser tab,
// because the proxy runs server-side on port 5000 and forwards to 8000.
const api = axios.create({
  timeout: 10000,
});

// Request interceptor to add auth token and selected group
api.interceptors.request.use(
  (config) => {
    // Ensure headers exist
    if (!config.headers) {
      config.headers = {};
    }
    
    // Add auth token
    const user = localStorage.getItem('user');
    const token = localStorage.getItem('token'); // Also check for standalone token
    
    if (user) {
      const userData = JSON.parse(user);
      
      // Use token from user object or standalone token
      const authToken = userData.token || token;
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      
      // Add selected group header for admins (but not platform admins)
      if (userData.role === 'ADMIN') {
        const selectedGroupId = localStorage.getItem('selectedPropertyGroup');
        if (selectedGroupId) {
          config.headers['x-selected-group'] = selectedGroupId;
        }
      }
    } else if (token) {
      // Handle case where token exists but no user object
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle group context errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If group context is invalid, clear it and redirect
    if (error.response?.status === 403 && 
        error.response?.data?.message?.includes('Invalid property group')) {
      localStorage.removeItem('selectedPropertyGroup');
      window.location.href = '/select-property-group';
    }
    return Promise.reject(error);
  }
);

export default api;